// extracted by mini-css-extract-plugin
export default {"button":"Cp-z","reviewSort":"Dp-z"};